import {VisualConversationTrackerModel} from '../../../../../src/components/inboxes/viewer/conversation/topbar/invite/inviteHelpers';

export function isParticipantRemovable(tracker: VisualConversationTrackerModel) {
  return (
    !tracker.isOwner && !tracker.isUserOrDelegatedTeammate && !tracker.isInboxMember && !tracker.isReader
  );
}
